var h = (o, n, t) => {
  if (!n.has(o))
    throw TypeError("Cannot " + t);
};
var c = (o, n, t) => (h(o, n, "read from private field"), t ? t.call(o) : n.get(o)), u = (o, n, t) => {
  if (n.has(o))
    throw TypeError("Cannot add the same private member more than once");
  n instanceof WeakSet ? n.add(o) : n.set(o, t);
}, p = (o, n, t, e) => (h(o, n, "write to private field"), e ? e.call(o, t) : n.set(o, t), t);
import { c as f, r as m } from "./lit-element-8JrrHldg.js";
import { P as C } from "./p-slot.component-Cn2P7TaX.js";
var v = Object.defineProperty, E = Object.getOwnPropertyDescriptor, b = (o, n, t, e) => {
  for (var s = e > 1 ? void 0 : e ? E(n, t) : n, l = o.length - 1, r; l >= 0; l--)
    (r = o[l]) && (s = (e ? r(n, t, s) : r(s)) || s);
  return e && s && v(n, t, s), s;
};
let d = class extends m {
  constructor(o) {
    super(), this.host = o;
  }
  createRenderRoot() {
    return this;
  }
};
d = b([
  f("pwc-root")
], d);
class g extends CustomEvent {
  constructor(n, t) {
    const e = "pwc-error", s = {
      component: n.toLowerCase(),
      error: t
    };
    super(e, { detail: s });
  }
}
var a;
class _ extends m {
  constructor() {
    super(...arguments);
    u(this, a, void 0);
    this.slots = {
      default: null
    }, this.slotted = {}, this.observer = new MutationObserver(async () => {
      var l;
      const t = Array.from(this.childNodes).filter(
        (r) => !(r instanceof d) && !(r instanceof C && r.host === this) && !(r instanceof HTMLElement && r.getAttribute("p-slot"))
      ), e = document.createDocumentFragment();
      t.forEach((r) => {
        e.appendChild(r);
      }), (l = this.slots.default) == null || l.appendChild(e), Array.from(this.childNodes).filter(
        (r) => r instanceof HTMLElement && r.getAttribute("p-slot")
      ).forEach((r) => {
        var i;
        (i = this.slots[r.getAttribute("p-slot")]) == null || i.appendChild(r);
      });
    }), p(this, a, async (t) => {
      var i;
      const e = t.target, s = e.name || "default";
      if (e.host !== this || !((i = this.slotControlled) != null && i.includes(s)))
        return;
      const l = e.hasContent(), r = this.slotted[s];
      l !== r && (this.slotted[s] = l, this.requestUpdate());
    });
  }
  createRenderRoot() {
    return document.createElement("pwc-root");
  }
  emit(t, e) {
    const s = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !1,
      detail: {},
      ...e
    });
    return this.dispatchEvent(s), s;
  }
  triggerError(t) {
    document.dispatchEvent(new g(this.tagName, t)), this.emit("error", {
      detail: {
        error: t
      }
    }), this.emit("p-error", {
      detail: {
        error: t
      }
    });
  }
  firstUpdated() {
    this.renderRoot.parentElement || this.appendChild(this.renderRoot);
  }
  slotConnected(t, e) {
    var l;
    const s = e || "default";
    this.slots[s] = t, (l = this.slotControlled) != null && l.includes(s) && (this.slotted[s] = t.hasContent(), this.requestUpdate());
  }
  slotDisconnected(t, e) {
    this.slots[e || "default"] = null;
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this.slotControlled) != null && t.length && this.addEventListener("p-slotchange", c(this, a)), this.observer.observe(this, { childList: !0, characterData: !0 });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("p-slotchange", c(this, a));
  }
}
a = new WeakMap();
export {
  _ as P
};
